<template>
    <div
        class="styled-multi-select"
        :class="{ disabled: disabled }"
    >
        <label class="form-group-label d-block mb-1">
            {{ label }}
        </label>

        <multiselect
            v-model="selected"
            @input="$emit('input', $event)"
            @open="fetch"
            @search-change="fetch"
            :allow-empty="allowEmpty"
            :close-on-select="closeOnSelect"
            :internal-search="!this.url"
            :loading="isLoading"
            :multiple="multiple"
            :options="optionsData"
            :placeholder="placeholder"
            :show-labels="false"
            open-direction="bottom"
            label="name"
            track-by="id"
            class="huge"
        >
            <template slot="noOptions">
                Zoeken
            </template>
            <template slot="noResult">
                Geen resultaten gevonden
            </template>
            <template
                slot="selection"
                slot-scope="{ values, isOpen }"
            >
                <span
                    v-if="values.length && !isOpen"
                    class="multiselect__single"
                >
                    <template v-if="values.length === 1">
                        {{ optionsData.find(item => item.id === values[0].id).name }}
                    </template>
                    <template v-else>
                        {{ values.length }}
                        Geselecteerd
                    </template>
                </span>
                <span v-else />
            </template>

            <div
                slot="afterList"
                class="create-section"
            >
                <slot />
            </div>
        </multiselect>
        <template v-if="name">
            <template v-if="multiple">
                <input
                    v-for="(input, index) in selected"
                    type="hidden"
                    :key="index"
                    :name="`${name}[]`"
                    :value="input.id"
                >
            </template>
            <input
                v-else
                type="hidden"
                :name="name"
                :value="selected.id"
            >
        </template>
        <input
            v-else
            :value="selected ? 'valid' : ''"
            :required="required"
            type="text"
            class="validate-input"
        >
    </div>
</template>

<script>
    import axios from 'axios';
    import Multiselect from 'vue-multiselect';

    export default {
        name: 'UiSelectSearch',
        components: {
            Multiselect,
        },
        props: {
            allowEmpty: {
                type: Boolean,
                default: true,
            },
            closeOnSelect: {
                type: Boolean,
                default: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
                default: null,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            options: {
                type: Array,
                default: () => [],
            },
            placeholder: {
                type: String,
                default: 'Zoek',
            },
            required: {
                type: Boolean,
                default: false,
            },
            selectedLoad: {
                type: Array,
                default: () => [],
            },
            url: {
                type: [String, Object],
                default: null,
            },
            value: {
                type: Array,
                default: () => [],
            },
            name: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                debounce: null,
                isLoading: false,
                optionsData: this.options,
                selected: [],
            };
        },
        methods: {
            fetch(q = '') {
                if (!this.url) return;

                clearTimeout(this.debounce);

                this.isLoading = true;

                this.debounce = setTimeout(async () => {
                    const { data } = await axios.get(this.url, { params: { q } });

                    this.optionsData = (Array.isArray(data)) ? data : data[Object.keys(data)];
                    this.isLoading = false;
                }, 250);
            },
        },
        watch: {
            selectedLoad: {
                immediate: true,
                handler() {
                    this.selected = this.selectedLoad;
                },
            },
            value: {
                immediate: true,
                handler() {
                    this.selected = this.value.map(item => {
                        return this.options.find(option => option.id === item);
                    }).filter(option => !!option);
                },
            },
        },
    };
</script>

<style lang="scss">
    .styled-multi-select .multiselect {
        min-width: 140px;
        min-height: $input-height;

        &__content-wrapper {
            width: auto;
            max-width: 600px;
            border-top: 1px solid $gray;
        }

        &__input {
            padding: 0;
            margin: 0;
            font-size: 16px;
        }

        &__tag {
            background: $primary;
        }

        &__tags {
            display: flex;
            align-items: center;
            min-height: inherit;
            padding: $input-padding-y $input-padding-x;
            margin: 0;
            font-size: $input-font-size;
            border-color: $input-border-color;
            border-radius: $radius;
        }

        &__tag-icon {
            width: 30px;
            line-height: 26px;
            background: darken($primary, 10);
            border-radius: 0 $radius $radius 0;

            &::after {
                font-size: 18px;
                color: darken($primary, 40);
            }

            &:hover {
                background: darken($primary, 30);
            }
        }

        &__placeholder {
            padding: 0;
            margin: 0;
            color: $gray;
        }

        &__option {
            font-size: 16px;

            &--highlight,
            &--highlight::after {
                color: $dark;
                background: $gray;
            }

            &--highlight::after {
                font-size: 12px;
                font-weight: bold;
            }
        }

        &__option--selected.multiselect__option--highlight {
            color: $light;
        }

        &__single {
            padding: 0;
            margin: 0;
            overflow: hidden;
            font-size: $input-font-size;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &__select {
            height: 100%;
        }
    }

    .multiselect__placeholder,
    .multiselect__single {
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            margin-top: 12px !important; // stylelint-disable-line
        }
    }
</style>

<style lang="scss" scoped>
    .validate-input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        opacity: 0;
    }
</style>
